import { Tab, Tabs } from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
import { DateTime } from 'luxon'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { Link } from 'react-router-dom'
import { CardContainer } from '../../components/Card'
import tableStyles from '../../components/Table/table.scss'
import tabsStyles from '../../components/Tabs/tabs.scss'
import BasicLayout from '../../layouts/BasicLayout'
import { dispatch, RootState, select, store } from '../../store'
import { getPaymentType } from '../../utils'
import orderHistoryStyles from './order-history-page.scss'

const cx = classnames.bind({ ...tabsStyles, ...tableStyles, ...orderHistoryStyles })

interface IProps extends
  ReturnType<typeof mapState>,
  RouteComponentProps<any> {
}

class OrderHistory extends React.PureComponent<IProps> {
  public state = {
    tab: 'success'
  }
  public handleTabChange = (tab: string) => {
    this.setState({ tab })
  }
  public handleRepaid = (lectureId: string) => {
    const { history } = this.props
    history.push(`/lectures/${lectureId}`)
  }
  public handleCancel = (tradeNo: string) => {
    dispatch.orders.deleteOrderById(tradeNo)
  }
  public render() {
    const { tab } = this.state
    return (
      <BasicLayout className={cx('page-OrderHistory')}>
        <div className={cx('container')}>
          <CardContainer className={cx('page-OrderHistory__main')}>
            <h3 className={cx('page-OrderHistory__title')}>訂單紀錄</h3>
            <div className={cx('page-OrderHistory__tabs-slider')}>
                <Tabs className={cx('tabs')} onChange={this.handleTabChange} selectedTabId={tab}>
                  <Tab
                    id="success"
                    title="購買成功"
                    className={cx('tabs__item')}
                    panel={this.renderSuccessPanel()} />
                  <Tab
                    id="unpaid"
                    title="待付款"
                    className={cx('tabs__item')}
                    panel={this.renderUnpaidPanel()} />
                  <Tab
                    id="failed"
                    title="付款失敗"
                    className={cx('tabs__item')}
                    panel={this.renderFailedPanel()} />
                  {/* <Tab id="refund" title="退款" className={cx('tabs__item')} panel={this.renderSuccessPanel()} /> */}
                </Tabs>
              </div>
          </CardContainer>

          {/* <!-- refund -->
				<!-- <div className={cx('tabs-content')}>
					<div className={cx('table-scroll')}>
						<table className={cx('table')}>
							<thead className={cx('table__thead')}>
								<tr>
									<th>購買講座</th>
									<th>購買日期</th>
									<th>購買總額</th>
									<th>付款方式</th>
									<th>訂單狀態</th>
									<th></th>
								</tr>
							</thead>
							<tbody className={cx('table__tbody')}>
								<tr>
									<td>如何精準跨入UI並高效學習如何精準跨入UI並高效學習</td>
									<td>2018/02/18</td>
									<td>NT$ 150</td>
									<td>ATM 轉帳</td>
									<td>
										<span className={cx('color--alert')}>待退款</span>
									</td>
									<td>
										<button className={cx('btn','btn--negative','btn--md','btn--line')}>取消退款</button>
									</td>
								</tr>
								<tr>
									<td>如何精準跨入UI並高效學習如何精準跨入UI並高效學習</td>
									<td>2018/02/18</td>
									<td>NT$ 150</td>
									<td>ATM 轉帳</td>
									<td>
										<span className={cx('color--positive')}>已退款</span>
									</td>
									<td></td>
								</tr>
							</tbody>
						</table>
						<div className={cx('table-empty')}>
							<p className={cx('para--sm')}>無退款記錄</p>
						</div>
					</div>
				</div> --> */}
        </div>
      </BasicLayout>
    )
  }
  public renderSuccessPanel = () => {
    const { paidOrders } = this.props
    return (
      <div className={cx('page-OrderHistory__tabs-scroll')}>
        <div className={cx('tabs-content')}>
          <div className={cx('table-scroll')}>
            <table className={cx('table')}>
              <thead className={cx('table__thead')}>
                <tr>
                  <th>購買講座</th>
                  <th>購買日期</th>
                  <th>購買總額</th>
                  <th>付款方式</th>
                  <th>訂單狀態</th>
                  {/* <th /> */}
                </tr>
              </thead>
              <tbody className={cx('table__tbody')}>
                {
                  paidOrders.map(order => {
                    const lecture = select.lectures.getById(store.getState(), order.lectureId)
                    return (
                      <tr key={order.ts.toMillis()}>
                        <td>{lecture ? <Link to={`/lectures/${order.lectureId}`}>{lecture.title}</Link> : null}</td>
                        <td>{DateTime.fromMillis(order.ts.toMillis()).toLocaleString(DateTime.DATETIME_SHORT)}</td>
                        <td>NT$ {order.trade.TotalAmount}</td>
                        <td>{getPaymentType(order.paymentType)}</td>
                        <td>
                          <span className={cx('color--positive')}>完成付款</span>
                          <br /><span className={cx('para--sm')}>{order.result ? order.result.PaymentDate : null}</span>
                        </td>
                        {/* <td>
                          <button className={cx('btn', 'btn--negative', 'btn--md', 'btn--line')}>收據</button>
                        </td> */}
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
            {
              paidOrders.length ? null : (
                <div className={cx('table-empty')}>
                  <p className={cx('heading-6')}>快來找找喜歡的講座吧～<a href="#!" className={cx('color--primary')}>探索講座</a></p>
                </div>
              )
            }
          </div>
        </div>
      </div>
    )
  }
  public renderUnpaidPanel = () => {
    const { unpaidOrders } = this.props
    return (
      <div>
        <div className={cx('tabs-content')}>
          <p className={cx('para--sm', 'u-mb-16')}>
          *若您使用超商付款，由於超商系統會有延遲4-5日的情形，請於4-5日後重新查詢訂單狀態，若仍有問題請與 Qraft 聯繫。
            <br />*付款成功將會發送email至您的信箱，如未收到信件，請與 Qraft 聯繫查詢。
            <br />*若超過期限未付款，訂單將轉移至「付款失敗」，請重新購買。
          </p>
          <div className={cx('table-scroll')}>
            <table className={cx('table')}>
              <thead className={cx('table__thead')}>
                <tr>
                  <th>購買講座</th>
                  <th>購買日期</th>
                  <th>購買總額</th>
                  <th>付款方式</th>
                  <th>訂單狀態</th>
                  <th />
                </tr>
              </thead>
              <tbody className={cx('table__tbody')}>
                {
                  unpaidOrders.map(order => {
                    const lecture = select.lectures.getById(store.getState(), order.lectureId)
                    return (
                      <tr key={order.ts.toMillis()}>
                        <td>{lecture ? <Link to={`/lectures/${order.lectureId}`}>{lecture.title}</Link> : null}</td>
                        <td>{DateTime.fromMillis(order.ts.toMillis()).toLocaleString(DateTime.DATETIME_SHORT)}</td>
                        <td>NT$ {order.trade.TotalAmount}</td>
                        <td>{getPaymentType(order.paymentType)}</td>
                        <td>
                          <span className={cx('color--alert')}>待付款</span>
                          {/* <br /><span className={cx('para--sm')}>{order.result ? order.result.PaymentDate : null}</span> */}
                        </td>
                        <td>
                          <button
                            className={cx('btn', 'btn--negative', 'btn--md', 'btn--line')}
                            onClick={this.handleCancel.bind(this, order.trade.MerchantTradeNo)}>取消訂單</button>
                        </td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
            {
              unpaidOrders.length ? null : (
                <div className={cx('table-empty')}>
                  <p className={cx('para--sm')}>尚無待付款的項目</p>
                </div>
              )
            }
          </div>
        </div>
      </div>
    )
  }
  public renderFailedPanel = () => {
    const { failedOrders } = this.props
    return (
      <div>
        <div className={cx('tabs-content')}>
          <div className={cx('table-scroll')}>
            <table className={cx('table')}>
              <thead className={cx('table__thead')}>
                <tr>
                  <th>購買講座</th>
                  <th>購買日期</th>
                  <th>購買總額</th>
                  <th>付款方式</th>
                  <th>訂單狀態</th>
                  <th />
                </tr>
              </thead>
              <tbody className={cx('table__tbody')}>
                {
                  failedOrders.map(order => {
                    const lecture = select.lectures.getById(store.getState(), order.lectureId)
                    return (
                      <tr key={order.ts.toMillis()}>
                        <td>{lecture ? <Link to={`/lectures/${order.lectureId}`}>{lecture.title}</Link> : null}</td>
                        <td>{DateTime.fromMillis(order.ts.toMillis()).toLocaleString(DateTime.DATETIME_SHORT)}</td>
                        <td>NT$ {order.trade.TotalAmount}</td>
                        <td>{getPaymentType(order.paymentType)}</td>
                        <td>
                          <span className={cx('color--alert')}>付款失敗</span>
                          <br /><span className={cx('para--sm')}>{order.result ? order.result.PaymentDate : null}</span>
                        </td>
                        <td>
                          <button className={cx('btn', 'btn--negative', 'btn--md', 'btn--line')} onClick={this.handleRepaid.bind(this, order.lectureId)}>重新購買</button>
                        </td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
            {
              failedOrders.length ? null : (
                <div className={cx('table-empty')}>
                  <p className={cx('para--sm')}>無付款失敗記錄</p>
                </div>
              )
            }
          </div>
        </div>
      </div>
    )
  }
}

const mapState = ({ orders, auth }: RootState) => {
  const rootState = store.getState()
  return {
    orders, auth,
    paidOrders: select.orders.getPaidOrders(rootState),
    unpaidOrders: select.orders.getUnpaidOrders(rootState),
    failedOrders: select.orders.getFailedOrders(rootState),
  }
}

export default connect(mapState)(OrderHistory)



// WEBPACK FOOTER //
// ./src/pages/OrderHistoryPage/index.tsx